const shippingCountries = [
  // supported
  {
    name: 'Australia',
    code: 'AU',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'au',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: { required: true },
      },
    },
    states: [
      {
        name: 'Australian Capital Territory',
        abbreviation: 'ACT',
      },
      {
        name: 'New South Wales',
        abbreviation: 'NSW',
      },
      {
        name: 'Northern Territory',
        abbreviation: 'NT',
      },
      {
        name: 'Queensland',
        abbreviation: 'QLD',
      },
      {
        name: 'South Australia',
        abbreviation: 'SA',
      },
      {
        name: 'Tasmania',
        abbreviation: 'TAS',
      },
      {
        name: 'Victoria',
        abbreviation: 'VIC',
      },
      {
        name: 'Western Australia',
        abbreviation: 'WA',
      },
    ],
  },
  {
    name: 'Austria',
    code: 'AT',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Belgium',
    code: 'BE',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    showTaxNotification: true,
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Canada',
    code: 'CA',
    showTaxNotification: true,
    channelKey: 'us',
    powerPlugType: 'us',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: { required: true },
      },
    },
    states: [
      {
        name: 'Alberta',
        abbreviation: 'AB',
      },
      {
        name: 'British Columbia',
        abbreviation: 'BC',
      },
      {
        name: 'Manitoba',
        abbreviation: 'MB',
      },
      {
        name: 'New Brunswick',
        abbreviation: 'NB',
      },
      {
        name: 'Newfoundland and Labrador',
        abbreviation: 'NL',
      },
      {
        name: 'Northwest Territories',
        abbreviation: 'NT',
      },
      {
        name: 'Nova Scotia',
        abbreviation: 'NS',
      },
      {
        name: 'Nunavut',
        abbreviation: 'NU',
      },
      {
        name: 'Ontario',
        abbreviation: 'ON',
      },
      {
        name: 'Prince Edward Island',
        abbreviation: 'PE',
      },
      {
        name: 'Quebec',
        abbreviation: 'QC',
      },
      {
        name: 'Saskatchewan',
        abbreviation: 'SK',
      },
      {
        name: 'Yukon',
        abbreviation: 'YT',
      },
    ],
  },
  {
    // Add District?
    // State is called Province
    // name: 'China',
    name: 'Mainland China',
    code: 'CN',
    channelKey: 'hk',
    powerPlugType: 'au',
    currency: 'USD',
    shipping: {
      enabled: true,
    },
  },
  {
    name: 'Croatia',
    code: 'HR',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Cyprus',
    code: 'CY',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU', 'EU_EXCEPTION__INCLUDE_INVOICE'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Denmark',
    code: 'DK',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'DKK',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: {
          hidden: true,
        },
        postalCode: {
          validation: '[0-9]{3,4}',
        },
      },
    },
  },
  {
    name: 'Estonia',
    code: 'EE',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Finland',
    code: 'FI',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    // Add Sorting code?
    name: 'France',
    code: 'FR',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Germany',
    code: 'DE',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Greece',
    code: 'GR',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    // State is called Area
    // Order: Address, District, Area
    // name: 'Hong Kong',
    name: 'Hong Kong - SAR of China',
    code: 'HK',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'uk',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: { optional: true, label: 'Area' },
        postalCode: { hidden: true },
      },
    },
  },
  {
    name: 'Hungary',
    code: 'HU',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Iceland',
    code: 'IS',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    // State is called Province
    name: 'Indonesia',
    code: 'ID',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'eu',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'Province',
        },
      },
    },
  },
  {
    name: 'Ireland',
    code: 'IE',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { optional: true },
      },
    },
  },
  {
    // State is called Province
    // Order: Postal code, City, Province
    name: 'Italy',
    code: 'IT',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'Province',
        },
      },
    },
  },
  {
    // State is called Prefecture?
    name: 'Japan',
    code: 'JP',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'jp',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'Prefecture',
        },
      },
    },
  },
  {
    // Order: City, Postal code
    name: 'Latvia',
    code: 'LV',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Lithuania',
    code: 'LT',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Malaysia',
    code: 'MY',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'uk',
    currency: 'USD',
    shipping: {
      enabled: true,
    },
  },
  {
    name: 'Malta',
    code: 'MT',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Monaco',
    code: 'MC',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Netherlands',
    code: 'NL',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'au',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Norway',
    code: 'NO',
    showTaxNotification: true,
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Philippines',
    code: 'PH',
    channelKey: 'hk',
    powerPlugType: 'us',
    currency: 'USD',
    shipping: {
      enabled: true,
    },
  },
  {
    name: 'Poland',
    code: 'PL',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Portugal',
    code: 'PT',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    name: 'Romania',
    code: 'RO',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
      },
    },
  },
  {
    // No city?
    name: 'Singapore',
    code: 'SG',
    channelKey: 'hk',
    powerPlugType: 'uk',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: { hidden: true },
        // city: { hidden: true},
      },
    },
  },
  {
    name: 'Slovakia',
    code: 'SK',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: {
          hidden: true,
        },
      },
    },
  },
  {
    name: 'Slovenia',
    code: 'SI',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: {
          hidden: true,
        },
      },
    },
  },
  {
    // State is named province
    // Order: Postal code, City, Province
    name: 'Spain',
    code: 'ES',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'Province',
        },
      },
    },
  },
  {
    // State is called Province
    name: 'South Korea',
    code: 'KR',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'eu',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'Province',
        },
      },
    },
  },
  {
    name: 'Sweden',
    code: 'SE',
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    trade: ['EU'],
    shipping: {
      enabled: true,
      fields: {
        state: {
          hidden: true,
        },
      },
    },
  },
  {
    name: 'Switzerland',
    code: 'CH',
    showTaxNotification: true,
    channelKey: 'dk',
    powerPlugType: 'eu',
    currency: 'EUR',
    shipping: {
      enabled: true,
      fields: {
        state: {
          hidden: true,
        },
      },
    },
  },
  {
    // State is named County
    // name: 'Taiwan',
    name: 'Taiwan Region',
    code: 'TW',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'us',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'County',
        },
      },
    },
  },
  {
    // State is named Province
    name: 'Thailand',
    code: 'TH',
    showTaxNotification: true,
    channelKey: 'hk',
    powerPlugType: 'us',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: {
          optional: true,
          label: 'Province',
        },
      },
    },
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    showTaxNotification: false,
    channelKey: 'dk',
    powerPlugType: 'uk',
    currency: 'GBP',
    shipping: {
      enabled: true,
      fields: {
        state: {
          hidden: true,
        },
        postalCode: {
          validation:
            '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}',
        },
      },
    },
  },
  {
    // Order: City, State, Zip code
    name: 'United States',
    code: 'US',
    channelKey: 'us',
    powerPlugType: 'us',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        postalCode: {
          validation: '[0-9]{5}',
        },
        state: { required: true },
      },
    },
    states: [
      {
        name: 'Alabama',
        abbreviation: 'AL',
      },
      {
        name: 'Alaska',
        abbreviation: 'AK',
      },
      {
        name: 'Arizona',
        abbreviation: 'AZ',
      },
      {
        name: 'Arkansas',
        abbreviation: 'AR',
      },
      {
        name: 'California',
        abbreviation: 'CA',
      },
      {
        name: 'Colorado',
        abbreviation: 'CO',
      },
      {
        name: 'Connecticut',
        abbreviation: 'CT',
      },
      {
        name: 'Delaware',
        abbreviation: 'DE',
      },
      {
        name: 'District of Columbia',
        abbreviation: 'DC',
      },
      {
        name: 'Florida',
        abbreviation: 'FL',
      },
      {
        name: 'Georgia',
        abbreviation: 'GA',
      },
      {
        name: 'Hawaii',
        abbreviation: 'HI',
      },
      {
        name: 'Idaho',
        abbreviation: 'ID',
      },
      {
        name: 'Illinois',
        abbreviation: 'IL',
      },
      {
        name: 'Indiana',
        abbreviation: 'IN',
      },
      {
        name: 'Iowa',
        abbreviation: 'IA',
      },
      {
        name: 'Kansas',
        abbreviation: 'KS',
      },
      {
        name: 'Kentucky',
        abbreviation: 'KY',
      },
      {
        name: 'Louisiana',
        abbreviation: 'LA',
      },
      {
        name: 'Maine',
        abbreviation: 'ME',
      },
      {
        name: 'Maryland',
        abbreviation: 'MD',
      },
      {
        name: 'Massachusetts',
        abbreviation: 'MA',
      },
      {
        name: 'Michigan',
        abbreviation: 'MI',
      },
      {
        name: 'Minnesota',
        abbreviation: 'MN',
      },
      {
        name: 'Mississippi',
        abbreviation: 'MS',
      },
      {
        name: 'Missouri',
        abbreviation: 'MO',
      },
      {
        name: 'Montana',
        abbreviation: 'MT',
      },
      {
        name: 'Nebraska',
        abbreviation: 'NE',
      },
      {
        name: 'Nevada',
        abbreviation: 'NV',
      },
      {
        name: 'New Hampshire',
        abbreviation: 'NH',
      },
      {
        name: 'New Jersey',
        abbreviation: 'NJ',
      },
      {
        name: 'New Mexico',
        abbreviation: 'NM',
      },
      {
        name: 'New York',
        abbreviation: 'NY',
      },
      {
        name: 'North Carolina',
        abbreviation: 'NC',
      },
      {
        name: 'North Dakota',
        abbreviation: 'ND',
      },
      {
        name: 'Ohio',
        abbreviation: 'OH',
      },
      {
        name: 'Oklahoma',
        abbreviation: 'OK',
      },
      {
        name: 'Oregon',
        abbreviation: 'OR',
      },
      {
        name: 'Pennsylvania',
        abbreviation: 'PA',
      },
      {
        name: 'Rhode Island',
        abbreviation: 'RI',
      },
      {
        name: 'South Carolina',
        abbreviation: 'SC',
      },
      {
        name: 'South Dakota',
        abbreviation: 'SD',
      },
      {
        name: 'Tennessee',
        abbreviation: 'TN',
      },
      {
        name: 'Texas',
        abbreviation: 'TX',
      },
      {
        name: 'Utah',
        abbreviation: 'UT',
      },
      {
        name: 'Vermont',
        abbreviation: 'VT',
      },
      {
        name: 'Virginia',
        abbreviation: 'VA',
      },
      {
        name: 'Washington',
        abbreviation: 'WA',
      },
      {
        name: 'West Virginia',
        abbreviation: 'WV',
      },
      {
        name: 'Wisconsin',
        abbreviation: 'WI',
      },
      {
        name: 'Wyoming',
        abbreviation: 'WY',
      },
    ],
  },
  {
    // State is called Province
    // Order: City, province, postal code
    name: 'Vietnam',
    code: 'VN',
    channelKey: 'hk',
    powerPlugType: 'eu',
    currency: 'USD',
    shipping: {
      enabled: true,
      fields: {
        state: {
          label: 'Province',
        },
      },
    },
  },
  // resellers
  {
    name: 'Russia',
    code: 'RU',
    showTaxNotification: true,
    channelKey: 'dk',
    currency: 'EUR',
    resellers: [
      {
        name: 'AIAIAI Russia',
        url: 'https://aiaiaistore.ru',
      },
    ],
    shipping: {
      enabled: false,
    },
  },
];

module.exports = shippingCountries;
